/** Single source for time-grid slot sizing (week/day views). Must stay in sync
 * with the `.calendar-container .ec-time-grid` rules in `ClientCalendar.css`
 * (@event-calendar/core positions events from JS using this pixel height).
 */
export const CLIENT_CALENDAR_TIME_GRID_SLOT_PX = 44;
